module.exports = __webpack_public_path__ + "img/hx-zyclyq-w.7cf3c29f.svg";